// Investment gain/loss math — mirrors the plan's §3 analytics.
// Per-investment computed fields (total_contributed, latest_value, gain_loss,
// gain_loss_pct) are provided by the backend list/get responses. Here we only
// need the portfolio-level aggregate for the list header.

const num = (v) => (typeof v === 'number' && !Number.isNaN(v) ? v : 0);

// Portfolio aggregate across all investments. For an investment with no value
// record yet, its current value is treated as total_contributed (0 gain — not a
// loss), exactly as §3 describes.
export const summarizeInvestments = (items = []) => {
  let totalContributed = 0;
  let totalCurrentValue = 0;

  items.forEach((inv) => {
    const contributed = num(inv.total_contributed);
    const current = inv.latest_value != null ? num(inv.latest_value) : contributed;
    totalContributed += contributed;
    totalCurrentValue += current;
  });

  const totalGainLoss = totalCurrentValue - totalContributed;
  const totalGainLossPct =
    totalContributed > 0 ? totalGainLoss / totalContributed : null;

  return {
    totalContributed,
    totalCurrentValue,
    totalGainLoss,
    totalGainLossPct,
  };
};

// Colour for a gain/loss figure: green >= 0, red < 0, neutral grey when there is
// no value recorded yet (gain/loss is unknown, don't imply a loss).
export const gainLossColor = (gainLoss) => {
  if (gainLoss == null) return '#9E9E9E';
  return gainLoss >= 0 ? '#4CAF50' : '#f44336';
};

// Display helper for money amounts (no currency util exists in this app).
export const formatMoney = (v) => {
  if (v == null || v === '') return '—';
  const n = typeof v === 'number' ? v : parseFloat(v);
  if (Number.isNaN(n)) return '—';
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatPct = (pct) => {
  if (pct == null) return '—';
  const sign = pct >= 0 ? '+' : '';
  return `${sign}${(pct * 100).toFixed(2)}%`;
};

export default summarizeInvestments;
